/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'pretty-checkbox-react';
import {
  closeModal, speak,
} from '../../actions';
import XIcon from '../../assets/contactus/x.svg';

class ContactModal extends Component {
  constructor() {
    super();
    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      message: '',
      firstnameError: false,
      lastnameError: false,
      emailError: false,
      messageError: false,
      checkError: false,
    };
  }

  sendEmail = () => {
    this.setState((prevState) => {
      return {
        firstnameError: prevState.firstname === '',
        lastnameError: prevState.lastname === '',
        emailError: !(/\S+@\S+\.\S+/.test(prevState.email)),
        messageError: prevState.message === '',
        checkError: !prevState.check1 && !prevState.check2 && !prevState.check3 && !prevState.check4,
      };
    }, () => {
      if (
        !this.state.firstnameError
        && !this.state.lastnameError
        && !this.state.emailError
        && !this.state.messageError
        && !this.state.checkError
      ) {
        let sub = '';

        if (this.state.check1) {
          sub += '\t\tLearn more about webinars, professional development & 1-1 consultations \n';
        }

        if (this.state.check2) {
          sub += '\t\tBecoming a corporate or college partner\n';
        }

        if (this.state.check3) {
          sub += '\t\tI want to stay in touch and receive videos, blog posts, and more info!\n';
        }

        if (this.state.check4) {
          sub += '\t\tOther\n';
        }

        let body = `
          -----The below message was auto-generated by the Contact Us form on the My Brain Explained site-----\n\n
          First name: ${this.state.firstname}\n\n
          Last name: ${this.state.lastname}\n\n 
          Email: ${this.state.email}\n\n
          What are you interested in?\n${sub}\n
          Custom Message:\n
          ${this.state.message}
        `;
        body = encodeURIComponent(body);
        window.location.href = `mailto:information@potentiainstitute21.org?cc=${this.state.email}&body=${body}&subject=MBE Question`;
      }
    });
  }

  handleCheck = (x) => {
    const y = `check${x}`;
    this.setState((prevState) => { return { [y]: !prevState[y] }; });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  render = () => {
    return (
      <div className="contact-body">
        <img className="contact-x-icon" src={XIcon} alt="x" onClick={() => { this.props.closeModal(); }} />
        <div className="email-box">
          <form>
            <div className="form-row">
              <div className="form-column">
                <label htmlFor="fname">First Name</label>
                {this.state.firstnameError ? <p className="contact-error-text">This field cannot be left blank</p> : null}
                <input type="text" id="fname" name="firstname" className="form-input" value={this.state.firstname} onChange={this.handleChange} />
              </div>
              <div className="form-column">
                <label htmlFor="lname">Last Name</label>
                {this.state.lastnameError ? <p className="contact-error-text">This field cannot be left blank</p> : null}
                <input type="text" id="lname" name="lastname" className="form-input" value={this.state.lastname} onChange={this.handleChange} />
              </div>
            </div>
            <div className="form-email">
              <label htmlFor="email">Email</label>
              {this.state.emailError ? <p className="contact-error-text">This email is incorrect</p> : null}
              <input type="text" id="email" name="email" className="form-input" value={this.state.email} onChange={this.handleChange} />
            </div>
            <div className="about-buttons">
              <div className="button-row-header">
                What are you interested in
                {this.state.checkError ? <p className="contact-error-text">Pick at least one option</p> : null}
              </div>
              <div className="button-row">
                <Checkbox shape="square" variant="thick" animation="smooth" onClick={() => { this.handleCheck(1); }}>
                  Learn more about webinars, professional development & 1-1 consultations
                </Checkbox>
              </div>
              <div className="button-row">
                <Checkbox shape="square" variant="thick" animation="smooth" onClick={() => { this.handleCheck(2); }}>
                  Becoming a corporate or college partner
                </Checkbox>
              </div>
              <div className="button-row">
                <Checkbox shape="square" variant="thick" animation="smooth" onClick={() => { this.handleCheck(3); }}>
                  I want to stay in touch and receive videos, blog posts, and more info!
                </Checkbox>
              </div>
              <div className="button-row">
                <Checkbox shape="square" variant="thick" animation="smooth" onClick={() => { this.handleCheck(4); }}>
                  Other
                </Checkbox>
              </div>
            </div>
            <div className="form-msg">
              <label htmlFor="message">Message</label>
              {this.state.messageError ? <p className="contact-error-text">This field cannot be left blank</p> : null}
              <textarea id="message" name="message" className="contact-msg" value={this.state.message} onChange={this.handleChange} />
            </div>
            <div className="form-row">
              <input type="button" value="Submit" className="submit-bubble" onClick={this.sendEmail} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => (
  { speechEnabled: state.speech.enabled }
);
export default connect(mapStateToProps, { speak, closeModal })(ContactModal);
